import React from 'react'
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../HistoryCompaignStyle';
import { Icon, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import * as HistoryActions from 'app/actions/HistoryCampaignActions';
import { useState } from 'react';


const TableScreen = (props) => {
    const dispatch = useDispatch();
    const {
        isLoadingHistoryCampaign,
        ListHistoryCampaign,
        pagination
    } = useSelector(state => state.HistoryCampaignReducer)
    const { idSubdirection } = useSelector((state) => state.Auth.employeeById);

    const { current, pageSize, total } = pagination;

    const dataSource = ListHistoryCampaign.map(
        (record) => {
            return {
                'key': record.rowNum,
                ...record
            }
        }
    );
    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }
    const handleTableChange = (pagination, filters, sorter) => {
        if (props.trainingF.length != 0) {
            dispatch(HistoryActions.fetchHistoryCampaign({
                offset: (pagination.current - 1) * pagination.pageSize,
                limit: pagination.pageSize,
                sortColumn: Object.keys(sorter).length > 0 ? sorter.field : undefined,
                sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined,
                SubDirectionOrigin: idSubdirection,
                ListTraining: props.trainingF.join(','),
                ListSpecialty: props.specialtyF.join(','),
                ListProgramCom: props.communicationF.join(','),
                ListProcedureMaterial: props.procedureF.join(',')
            }))
        }
    }

    const columns = [
        {
            title: 'Sistema/Especialidad',
            dataIndex: 'specialtyOrSystem',
            key: '1',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Programa de Comunicación',
            dataIndex: 'communicationProgramName',
            key: '2',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Proc./Mat. de Capacitación',
            dataIndex: 'courseName',
            key: '3',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Fecha',
            dataIndex: 'diffusionStartDate',
            key: '4',
            sorter: true,
            ellipsis: true,
            width: 120
        },
        {
            title: 'Ficha',
            dataIndex: 'file',
            key: '5',
            sorter: true,
            ellipsis: true,
            width: 120
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: '6',
            sorter: true,
            ellipsis: true,
            width: 300
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: '7',
            sorter: true,
            ellipsis: true,
            width: 120
        },
        {
            title: 'Evaluación',
            dataIndex: 'test',
            key: '8',
            sorter: true,
            ellipsis: true,
            width: 120
        },
        {
            title: 'Fecha Eval.',
            dataIndex: 'dateTes',
            key: '9',
            sorter: true,
            ellipsis: true,
            width: 120
        },
    ];

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <Table
            loading={isLoadingHistoryCampaign}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "min-content" }}
            scroll={{ x: 'min-content', y: (height - 495) }}
            size={"small"}
            onChange={handleTableChange}

        />
    )
}
export default TableScreen;
